__turbopack_context__.v({
  "addIcon": "managePortfoliosModal-module-scss-module__BUQGRq__addIcon",
  "addPortfolioButton": "managePortfoliosModal-module-scss-module__BUQGRq__addPortfolioButton",
  "addPortfolioButtonDisabled": "managePortfoliosModal-module-scss-module__BUQGRq__addPortfolioButtonDisabled",
  "addPortfolioButtonTitle": "managePortfoliosModal-module-scss-module__BUQGRq__addPortfolioButtonTitle",
  "addPortfolioButtonWrapper": "managePortfoliosModal-module-scss-module__BUQGRq__addPortfolioButtonWrapper",
  "deleteIcon": "managePortfoliosModal-module-scss-module__BUQGRq__deleteIcon",
  "deleteIconContainer": "managePortfoliosModal-module-scss-module__BUQGRq__deleteIconContainer",
  "description": "managePortfoliosModal-module-scss-module__BUQGRq__description",
  "draggableArea": "managePortfoliosModal-module-scss-module__BUQGRq__draggableArea",
  "draggableIcon": "managePortfoliosModal-module-scss-module__BUQGRq__draggableIcon",
  "fieldContainer": "managePortfoliosModal-module-scss-module__BUQGRq__fieldContainer",
  "footer": "managePortfoliosModal-module-scss-module__BUQGRq__footer",
  "footerBottomButtons": "managePortfoliosModal-module-scss-module__BUQGRq__footerBottomButtons",
  "header": "managePortfoliosModal-module-scss-module__BUQGRq__header",
  "list": "managePortfoliosModal-module-scss-module__BUQGRq__list",
  "listHeader": "managePortfoliosModal-module-scss-module__BUQGRq__listHeader",
  "listHeaderTitle": "managePortfoliosModal-module-scss-module__BUQGRq__listHeaderTitle",
  "modal": "managePortfoliosModal-module-scss-module__BUQGRq__modal",
  "numberSign": "managePortfoliosModal-module-scss-module__BUQGRq__numberSign",
  "portfolio": "managePortfoliosModal-module-scss-module__BUQGRq__portfolio",
  "saveButton": "managePortfoliosModal-module-scss-module__BUQGRq__saveButton",
  "saveButtonFetching": "managePortfoliosModal-module-scss-module__BUQGRq__saveButtonFetching",
  "scrollableContent": "managePortfoliosModal-module-scss-module__BUQGRq__scrollableContent",
  "sequenceNumber": "managePortfoliosModal-module-scss-module__BUQGRq__sequenceNumber",
  "title": "managePortfoliosModal-module-scss-module__BUQGRq__title",
  "wrapper": "managePortfoliosModal-module-scss-module__BUQGRq__wrapper",
});
